import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import { iv } from './iv';
import { cp } from './cp';

import cView from './cView';

export default class cPdtCtgList extends cView {
  //
  $id_stgs = { // 子で上書き
    cLoadCnd: () => bf.q('[cm5tb11k]="{}"'.f(
      global.c?.state.sgcd_pageCmns?.cm20_key,
    )),
  };
  //
  $cd_stss = { // 親を上書き
    sld_cm5tss: {},
  };
  //
  $clp_loads = () => [ // 親を上書き
    cp.$cp_hlr_cm5t({
      mode: 'items',
      state: 'sld_cm5tss',
      cnd: global.c?.$id_stgs.cLoadCnd(),
    })
  ];
  //
  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={true}
        onSchEnt={null}
        b_rhtVsb={true}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iPdtCtgDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: '',
          d_leftBtns: {},
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm5tss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iPdtCtgDtl',
              nextMode: 'show',
              keyName: 'cm5t_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            }
          ]
        }}
      />
    );
  }
}
